import React, { ChangeEvent, useRef } from 'react';
import styles from './ProfileImageInput.module.scss';
import cx from 'classnames';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import avatarPlaceholder from '../../assets/avatar_placeholder.png';

type Props = {
  name: string;
  value: File | File[] | string | string[] | undefined;
  onFileChange?: (event: ChangeEvent<any>) => void;
  errors?: Array<string>;
  disabled?: boolean;
};

const ProfileImageInput = ({
  onFileChange,
  value,
  name,
  errors,
  disabled,
}: Props) => {
  const uploadInputRef = useRef<HTMLInputElement | null>(null);

  const handleUploadCLick = () => {
    if (uploadInputRef.current) {
      uploadInputRef.current.click();
    }
  };

  const renderImage = (value: File | string | undefined, index: number) => {
    return (
      <div key={`image-${index}`} className={styles.imageContainer}>
        {value instanceof File ? (
          <img src={URL.createObjectURL(value)} alt={value.name} />
        ) : (
          <img
            src={value ? value.toString() : avatarPlaceholder}
            alt={value?.toString() || ''}
          />
        )}
      </div>
    );
  };

  return (
    <>
      <div
        className={cx(styles.fileFieldContainer, {
          [styles.disabled]: disabled,
        })}
      >
        <div className={styles.fileField}>
          <input
            color="primary"
            type="file"
            onChange={onFileChange}
            ref={uploadInputRef}
            name={name}
            disabled={disabled}
          />
          <div className={styles.fileContainer}>
            <div
              className={styles.fileSelectedContainer}
              onClick={!disabled ? handleUploadCLick : () => {}}
            >
              {renderImage(value as File | string | undefined, 0)}
              <div
                className={cx(styles.photoIcon, {
                  [styles.placeholderActive]: !value,
                })}
              >
                <AddAPhotoIcon />
              </div>
            </div>
          </div>
        </div>
      </div>
      {errors &&
        errors.map((error, index) => (
          <div className={styles.fileError} key={`file-error-${index}`}>
            {error}
          </div>
        ))}
    </>
  );
};

export default ProfileImageInput;
